<template>
  <v-container fluid class="pa-0">
    <v-progress-linear v-if="loading" :indeterminate="loading" absolute>
    </v-progress-linear>

    <!--
    <v-card v-if="ParentJobLogg && ParentJobLogg.length > 0"
            class="ma-4">
      <v-list-item>
        <v-list-item-icon class="mr-3">
          <v-icon class="material-icons"
                  v-text="'$job'"
                  color="primary" />
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="primary--text">
            {{PartentJobId}}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn @click="openNew(PartentJobId)"
                 dark
                 color="primary"
                 small>
            <v-icon>mdi-plus</v-icon>
            add logg
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-list v-if="ParentJobLogg.length > 0"
              class="py-0 limitheight"
              dense>
        <logg-li v-for="loggitem in oddMarkList(ParentJobLogg)"
                 :key="loggitem.Id"
                 :item="loggitem"
                 @fetch="select">
        </logg-li>
      </v-list>
      <div v-else
           class="pl-4 pb-3">
        No loggs
      </div>
    </v-card>
    -->
    <v-container fluid>
      <v-row no-gutters>
        <v-col :cols="isPhoneBool ? 12 : 6" :class="isPhoneBool ? 'pb-3' : 'pr-3'">
          <h3 v-text="$t('servicesystem.common_objects.job.support_logg')" />
          <template v-if="Subjobs && Subjobs.length > 0">
            <SupportLoggCard v-for="subjob in Subjobs" :key="subjob.Id" :subjob="subjob">
            </SupportLoggCard>
          </template>
          <!--
             <empty-page v-else-if="loaded" :icon="'mdi-timeline-clock'"
              :title="$t('servicesystem.common_objects.fallbackterms.no_loggs')"
              :message="$t('servicesystem.common_objects.fallbackterms.found_no_loggs')">
                <template v-slot:actions>
                </template>
              </empty-page>
          -->
        </v-col>
        <v-divider v-if="!isPhoneBool" vertical></v-divider>
        <v-col :cols="isPhoneBool ? 12 : 6" :class="isPhoneBool ? 'pb-3' : 'pl-3'">
          <h3 v-text="$t('servicesystem.common_objects.job.audit_logg')" />
          <JobLoggTimeline />
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SupportLoggCard from "@/views/job/viewjob/SupportLoggCard.vue";
import JobLoggTimeline from "@/views/job/viewjob/JobLoggTimeline.vue";
//import EmptyPage from "@/components/Sections/EmptyPage.vue";

export default {
  name: "ViewJobLogg",
  components: {
    SupportLoggCard,
    //EmptyPage
    JobLoggTimeline,
  },
  mixins: [clientAPI],

  data() {
    return {
      loading: false,
      ParentJobLogg: null,
    };
  },

  mounted() {
    this.getParentJobLogg();
  },

  methods: {
    getParentJobLogg() {
      this.loading = true;
      this.getLoggByJobId(this.PartentJobId)
        .then((response) => {
          this.ParentJobLogg = response;
        })
        .catch((exception) => console.log(exception))
        .finally(() => (this.loading = false));
    },
  },

  computed: {
    PartentJobId() {
      return this.$route.params.jobId;
    },
    Subjobs() {
      return this.$store.getters["JobHub/Subjobs"];
    },
  },

  watch: {
    "Subjobs.length"() {
      this.getParentJobLogg();
    },
  },
};
</script>

<style lang="scss" scoped>
.limitheight {
  max-height: 50vh;
  overflow-y: auto;
}
</style>